import {Link, useLocation} from 'react-router-dom';
import React, {useContext, useState} from 'react';
//import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';
//import AudioPlayer from './components/audio/audioplayer';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import moment from 'moment';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

//import './css/header.css';

export default function Footer() {

	const {user} = useContext(UserContext);

	return (
		<>
			{user?.user &&
				<footer className="footer mt-auto py-3 bg-white text-center">
					<div className="container">
						<span className="text-muted"> Copyright © <span id="year">{moment().format("YYYY")}</span>&nbsp;
							<Link to="/" className="text-dark fw-semibold">ultrastream.io</Link>.
						</span>
					</div>
				</footer>
			}
		</>
	);
}
